import Fields from './fields/PluginSetup.js'

export default {
  install( plugins ) {
    Fields.install( plugins )
  }
}
